export default __webpack_public_path__ + "static/media/multilineTextInput.32f94b45.gif";